// The one list of IPC Global apps for the app switcher (portal workbench
// spec, "App switcher and footer content"). Staff entries are URLs only, no
// data: the target apps enforce their own access, IP restriction included.
// On a NON-PROD build an entry uses its NON-PROD URL, or is hidden when it
// has none: PLATMAN has one PROD instance and no NON-PROD one, and no
// NON-PROD URL is known yet for IPC Global on AWS Marketplace (add it to
// its urls.nonProd when there is one).

export const AUDIENCE = Object.freeze({ EVERYONE: 'everyone', STAFF: 'staff' });

export const APPS = Object.freeze([
  {
    id: 'onguard-entraid',
    name: 'onGuard for Entra ID',
    description: 'Audit data and security posture for your Microsoft Entra ID tenant.',
    audience: AUDIENCE.EVERYONE,
    current: true,
    urls: { prod: null, nonProd: null },
  },
  {
    id: 'marketplace',
    name: 'IPC Global on AWS Marketplace',
    description: 'Subscribe to IPC Global products through AWS Marketplace.',
    audience: AUDIENCE.EVERYONE,
    urls: { prod: 'https://marketplace.ipc-global.com', nonProd: null },
  },
  {
    id: 'support',
    name: 'IPC Global Support',
    description: 'Open and track support requests.',
    audience: AUDIENCE.EVERYONE,
    urls: { prod: 'https://support.ipc-global.com', nonProd: 'https://support.ipc-global.com' },
  },
  {
    id: 'website',
    name: 'IPC Global website',
    description: 'Products, services and news from IPC Global.',
    audience: AUDIENCE.EVERYONE,
    urls: { prod: 'https://www.ipc-global.com', nonProd: 'https://www.ipc-global.com' },
  },
  {
    id: 'idp-admin',
    name: 'IdP Admin',
    description: 'Manage users, tenants and roles on the IPC Global identity provider.',
    audience: AUDIENCE.STAFF,
    urls: { prod: 'https://idp-admin.ipc-global.com/admin', nonProd: 'https://idp-admin.directit.services/admin' },
  },
  {
    id: 'platman',
    name: 'PLATMAN',
    description: 'IPC Global platform management.',
    audience: AUDIENCE.STAFF,
    urls: { prod: 'https://platman.corporate.directit.services', nonProd: null },
  },
].map((app) => Object.freeze({ ...app, urls: Object.freeze(app.urls) })));

/**
 * The apps this user may see in this environment, each with its link (null for
 * the current app). Fail-safe: only the exact string 'Production' gets PROD
 * URLs; an omitted or unknown environment counts as NON-PROD.
 */
export function appsFor({ isOperator = false, environment } = {}) {
  const nonProd = environment !== 'Production';
  return APPS
    .filter((app) => app.audience === AUDIENCE.EVERYONE || (app.audience === AUDIENCE.STAFF && isOperator === true))
    .map((app) => ({ ...app, href: app.current ? null : (nonProd ? app.urls.nonProd : app.urls.prod) }))
    .filter((app) => app.current === true || Boolean(app.href));
}
